import React from "react";

function StatusUpdateDialog(props: any) {
    const getMessage = (status: string) => {
        switch (status) {
            case "CANCEL":
                return "cancel services";

            case "REACTIVATE":
                return "reactivate services";

            case "RESEND-INVITE":
                return "resend invite";

            default:
                return "";
        }
    };

    return (
        <>
            <div className="dialog-header">
                <div className="justify-center">
                    <h3>Are you Sure?</h3>
                </div>
            </div>
            <div className={props.isLoading ? "loading dialog-body flex-center f-dir-column" : "dialog-body flex-center f-dir-column"}>
                <p>
                    If you continue, you will {getMessage(props.status)} for{" "}
                    {props.isBulkAction && props.selectedRowKeys.length > 1 ? "these employees" : "this employee"}.
                </p>
                <p className="bold">Are you sure you want to continue?</p>
            </div>
            <div className="dialog-footer">
                <div className="row">
                    <div className="col-xs-12 col-no-gutter flex-grow-null" style={{ display: "flex", justifyContent: "space-between" }}>
                        <button type="button" className="btn-default" onClick={props.closeDialog}>
                            <span className="btn-text">Cancel</span>
                        </button>
                        <button type="button" className="btn-default btn-primary" onClick={props.handleContinue}>
                            <span className="btn-text">Continue</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default StatusUpdateDialog;
